<template>
  <customModal :containersm="true" :footerShow="false" @closeModal="$emit('close')">
    <template #title>
      {{ $t("navigations.add new version") }}
    </template>

    <template #body>
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-label">{{ $t("navigations.new version") }}</label>
            <input
              type="text"
              v-model="version"
              class="form-control"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-label">{{ $t("navigations.effective date") }}</label>
            <input
              type="date"
              v-model="effectiveDate"
              class="form-control"
            />
          </div>
        </div>
          <div class="row mb-3">
             <div class="col-md-12">
                    <label class="col-form-label me-2 pt-0">{{ $t("navigations.active") }}</label>
                    <input type="checkbox" v-model="isActive" />
                </div>
                 </div>

        <div class="text-right">
          <button
            type="button"
            class="btn btn-primary btn-sm py-0 px-3 mt-2"
            @click="saveVersionDetails"
          >
            {{ $t("navigations.save") }}
          </button>
        </div>
      </div>
    </template>
  </customModal>
</template>
<script src="./LabTestVersionModal.js"></script>